import React from 'react';
import { Loader2 } from 'lucide-react';

const AiProcessingOverlay = ({ isActive }) => {
  if (!isActive) {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.5)', // Półprzezroczyste tło
      backdropFilter: 'blur(5px)', // Efekt blur
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000, // Upewnij się, że jest na wierzchu
      color: 'white',
      textAlign: 'center',
      padding: '20px'
    }}>
      <Loader2 size={48} className="animate-spin" style={{ marginBottom: '20px' }} />
      <h2 style={{ fontSize: '1.5rem', marginBottom: '10px' }}>
        Trwa generowanie nowego projektu przez AI...
      </h2>
      <p style={{ fontSize: '1rem' }}>
        Prosimy o cierpliwość. To może potrwać kilka minut.
      </p>
      <p style={{ fontSize: '0.9rem', marginTop: '5px' }}>
        Możesz bezpiecznie zamknąć to okno, informacje o nowym projekcie wyślemy Ci na maila, jeśli wcześniej podałaś adres mailowy
      </p>
    </div>
  );
};

export default AiProcessingOverlay;
